import { client } from "./client";
import interceptors from "./interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getPDO(params) {
	return client.get("api/pdo/data", {
		params: params,
	});
}

function getPDOAll(params) {
	return client.get("api/pdo/all", {
		params: params,
	});
}

function getOptionStatus() {
	return client.get("api/options/pdo-status");
}

function exportPDO(params) {
	return client.get("api/pdo/export", {
		params: params,
	});
}

function exportPDOAll(params) {
	return client.get("api/pdo/export-all", {
		params: params,
	});
}

function getDetailPDO(params) {
	return client.get("api/pdo/detail", {
		params: {
			pdo_code: params
		},
	});
}

function receivePDO (params) {
	return client.post("api/pdo/receive", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getPDO,
	getPDOAll,
	getOptionStatus,
	getDetailPDO,
	exportPDO,
	exportPDOAll,
	receivePDO
};